import React, { useState, forwardRef, useRef } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import SecuredImage from 'modules/common/components/SecuredImage';
import Modal from 'modules/common/components/Modal';
import * as actions from '../actions';

const ComponentToPrint = forwardRef(({ src, rotation, heightWidth }, ref) => {
  const imgSrc = src;
  return (
    <SecuredImage
      ref={ref}
      onContextMenu={e => {
        e.preventDefault();
        return false;
      }}
      alt="BC"
      style={{
        transform: ` rotate(${rotation}deg)`,
        width: `${heightWidth}`,
        height: `${heightWidth}`,
      }}
      src={imgSrc}
    />
    // <embed src={src} title="BC Photo" />
  );
});

ComponentToPrint.propTypes = {
  src: PropTypes.string.isRequired,
  rotation: PropTypes.number.isRequired,
  heightWidth: PropTypes.string.isRequired,
};

function ViewReceipt({ receiptUrl }) {
  const [heightWidth, setHeightWidth] = useState('auto');
  const [rotation, setRotation] = useState(0);

  const toPrintContentRef = useRef();

  const onRotateLeft = e => {
    e.preventDefault();
    let newRotation = rotation - 90;
    if (newRotation === -360) {
      newRotation = 0;
      setRotation(newRotation);
    }

    const rotationArray = [-90, 270, 90, -270];

    if (rotationArray.includes(newRotation)) {
      setHeightWidth('480px');
    } else {
      setHeightWidth('auto');
    }

    setRotation(newRotation);
  };

  const onRotateRight = e => {
    e.preventDefault();
    let newRotation = rotation + 90;
    if (newRotation === 360) {
      newRotation = 0;
      setRotation(newRotation);
    }

    const rotationArray = [90, 270, -90, -270];

    if (rotationArray.includes(newRotation)) {
      setHeightWidth('480px');
    } else {
      setHeightWidth('auto');
    }

    setRotation(newRotation);
  };
  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 mt-3">
          <div div className="d-flex justify-content-between mb-3">
            <button
              type="button"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
              onClick={onRotateLeft}
            >
              <i className="fa fa-arrow-left" />
              &nbsp;ROTATE LEFT
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
              onClick={onRotateRight}
            >
              ROTATE RIGHT&nbsp;
              <i className="fa fa-arrow-right" />
            </button>
          </div>
          <div className="dc-wrapper d-flex justify-content-center">
            <ComponentToPrint
              className="w-100 border"
              rotation={rotation}
              heightWidth={heightWidth}
              src={receiptUrl}
              ref={toPrintContentRef}
            />
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}
ViewReceipt.propTypes = {
  receiptUrl: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewReceipt);
